export class GetCaptchaPublicKeyRequest {
    Accept: string = 'application/json';
    transId: string = 'b43d43e2737e42e2a4b16f4c6f8cdce2';
    transactionSrc: string = 'UPPLM';
    platformType: string = 'P9';
    AccessLicenseNumber: '';
    authorization: string = '503896c4b4824718aeb80f3dc7bfa8da';    
    transactionID: string = '';    
}

export class GetCaptchaPublicKeyResponse {
    captchaPublicKey: string;
    Error: string;
}